import React from 'react';
import './CookiePolicy.css';

function CookiePolicy() {
  return (
    <div className="cookie-policy-page">
      <div className="container">
        <div className="cookie-content">
          <h1>Cookie Policy</h1>
          
          <div className="cookie-section">
            <h2>What Are Cookies?</h2>
            <p>
              Cookies are small text files that are placed on your device when you visit our website. 
              They help us provide you with a better experience by remembering your preferences, 
              analyzing how you use our site, and personalizing content and advertisements.
            </p>
          </div>

          <div className="cookie-section">
            <h2>How We Use Cookies</h2>
            <p>We use cookies for the following purposes:</p>
            
            <h3>Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function properly. They enable basic 
              functions like page navigation, access to secure areas, and form submissions. 
              The website cannot function properly without these cookies.
            </p>
            <ul>
              <li>Session management and security</li>
              <li>User authentication</li>
              <li>Form submissions and validation</li>
              <li>Language preferences</li>
            </ul>

            <h3>Analytics Cookies</h3>
            <p>
              These cookies help us understand how visitors interact with our website by collecting 
              and reporting information anonymously.
            </p>
            <ul>
              <li>Google Analytics - to analyze website traffic and user behavior</li>
              <li>Page view tracking and user journey analysis</li>
              <li>Performance monitoring and optimization</li>
            </ul>

            <h3>Advertising Cookies</h3>
            <p>
              These cookies are used to deliver relevant advertisements and track advertising campaign performance.
            </p>
            <ul>
              <li>Google Ads - to display personalized advertisements</li>
              <li>Remarketing and audience targeting</li>
              <li>Ad performance measurement</li>
              <li>Cross-site tracking for advertising purposes</li>
            </ul>

            <h3>Functional Cookies</h3>
            <p>
              These cookies enable enhanced functionality and personalization, such as remembering 
              your preferences and settings.
            </p>
            <ul>
              <li>Job search preferences and filters</li>
              <li>User interface customization</li>
              <li>Social media integration</li>
            </ul>
          </div>

          <div className="cookie-section">
            <h2>Third-Party Cookies</h2>
            <p>
              We use third-party services that may set cookies on your device:
            </p>
            <ul>
              <li><strong>Google Analytics:</strong> Website analytics and performance tracking</li>
              <li><strong>Google Ads:</strong> Advertising and remarketing services</li>
              <li><strong>Social Media Platforms:</strong> Facebook, Twitter, LinkedIn, Instagram integration</li>
              <li><strong>Email Services:</strong> Newsletter and job alert delivery</li>
            </ul>
            <p>
              These third parties have their own privacy policies and cookie practices. 
              We recommend reviewing their policies for more information.
            </p>
          </div>

          <div className="cookie-section">
            <h2>Cookie Duration</h2>
            <p>Cookies on our website may be:</p>
            <ul>
              <li><strong>Session Cookies:</strong> Temporary cookies that expire when you close your browser</li>
              <li><strong>Persistent Cookies:</strong> Cookies that remain on your device for a set period or until manually deleted</li>
            </ul>
          </div>

          <div className="cookie-section">
            <h2>Managing Your Cookie Preferences</h2>
            <p>
              You can control and manage cookies in several ways:
            </p>
            
            <h3>Browser Settings</h3>
            <p>
              Most web browsers allow you to control cookies through their settings. You can:
            </p>
            <ul>
              <li>Block all cookies</li>
              <li>Allow cookies only from trusted sites</li>
              <li>Delete existing cookies</li>
              <li>Set preferences for different types of cookies</li>
            </ul>

            <h3>Opt-Out Options</h3>
            <p>
              You can opt out of certain types of cookies:
            </p>
            <ul>
              <li><strong>Google Analytics:</strong> <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a></li>
              <li><strong>Google Ads:</strong> <a href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer">Google Ads Settings</a></li>
              <li><strong>Network Advertising Initiative:</strong> <a href="http://optout.networkadvertising.org/" target="_blank" rel="noopener noreferrer">NAI Opt-out</a></li>
            </ul>

            <h3>Cookie Consent</h3>
            <p>
              When you first visit our website, you will see a cookie consent banner. 
              You can change your preferences at any time by clicking the "Cookie Settings" 
              link in our footer.
            </p>
          </div>

          <div className="cookie-section">
            <h2>Your Rights (GDPR/CCPA)</h2>
            <p>
              Under data protection laws, you have the following rights regarding cookies:
            </p>
            <ul>
              <li><strong>Right to Information:</strong> You have the right to be informed about our use of cookies</li>
              <li><strong>Right to Consent:</strong> You can give or withdraw consent for non-essential cookies</li>
              <li><strong>Right to Access:</strong> You can request information about what data we collect</li>
              <li><strong>Right to Deletion:</strong> You can request deletion of your personal data</li>
              <li><strong>Right to Portability:</strong> You can request a copy of your data in a portable format</li>
            </ul>
          </div>

          <div className="cookie-section">
            <h2>Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes in our 
              practices or for legal reasons. We will notify you of any material changes 
              by posting the updated policy on this page and updating the "Last Updated" date.
            </p>
          </div>

          <div className="cookie-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about our use of cookies or this Cookie Policy, 
              please contact us:
            </p>
            <ul>
              <li>Email: info@jobsopportunity.in</li>
              <li>Phone: +91-9380867233</li>
              <li>Website: https://jobsopportunity.in</li>
            </ul>
          </div>

          <div className="cookie-footer">
            <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
            <p>
              By continuing to use our website, you consent to our use of cookies as described in this policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy; 